import { toast } from 'sonner';

import { useAsyncExports } from '@/hooks/useAsyncExports';
import { useDownloadFile } from '@/hooks/useFiles';
import { useMutation } from '@/utils/api';
//
export const useExportRisks = () => {
  const { mutateAsync: exportRisks } = useAsyncExports('risk', true);
  const { mutateAsync: downloadFile } = useDownloadFile();

  return useMutation({
    defaultErrorMessage: 'Failed to export vulnerabilities',
    mutationFn: async ({ email }: { email: string }) => {
      const promise = async () => {
        const exportResult = await exportRisks({
          query: {
            node: {
              labels: ['Risk'],
              filters: [],
              relationships: [],
            },
            orderBy: 'name',
            descending: false,
          },
          format: 'csv',
          email,
        });
        if (exportResult.dns) {
          await downloadFile({
            email: email,
            name: exportResult.dns,
            downloadName: exportResult.dns,
            type: 'text/csv',
            responseType: 'blob',
          });
        }
      };

      toast.promise(promise, {
        success: 'vulnerabilities exported successfully',
        error: 'Failed to export vulnerabilities',
        loading: 'Exporting vulnerabilities...',
      });

      return promise;
    },
  });
};

export default useExportRisks;
